import accordion from "./components/accordion";
import momentsJs from "./components/historySlider";

export default function aboutJs() {
	momentsJs();
	document.querySelectorAll('[data-js="accordion"]').forEach((elem) => {
		accordion(elem, true);
	});
}
